import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-tenant-certification-details',
    templateUrl: './tenant-certification-details.component.html',
    styleUrls: ['./tenant-certification-details.component.scss'],
    standalone: false
})

export class TenantCertificationDetailsComponent implements OnInit {
  value: any;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
    public matdialogRef: MatDialogRef<TenantCertificationDetailsComponent>) {
      this.value = data;
    // if (data.selectable != null) {
    //   this.selectable = data.selectable;
    // }
    // this.selectedDocumentation = this.mockedDocumentationData[0].title;
  }

  ngOnInit(): void {

    // if(this.releaseVersion && this.solutionVersionsService.releaseVersion(this.releaseVersion)) {
    //   this.isAMR = true;
    // }

  }

  // selectDocumentation(documentation: any): void {
  //   this.selectedDocumentation = documentation.title;
  // }

  // toggleSelection(): void {
  //   this.capability.selected = !this.capability.selected;
  //   this.selectionChanged.emit(this.capability);
  //   this.selectionChangedData(this.capability);
  //   this.matdialogRef.close(this.capability);
  // }

  // selectionChangedData(changedCapability: Capability): void {
  //   const selectedCapabilities = [];
  //   selectedCapabilities.push(changedCapability);
  //   this.toastrService.clear();
  // }

  // titleCaseWord(word): void {
  //   if (!word) { return word; }
  //   return word[0].toUpperCase() + word.substr(1).toLowerCase();
  // }
}

